import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./PricingPlans.css";
import SubscriptionModal from "./SubscriptionModal/SubscriptionModal";
import { getData } from "../../../../Services/Api";
import { GetUserDetails } from "../../../../Helpers/Utility";
import LoginModal from "../../../../Auth/LoginModal/LoginModal";
import SignupModal from "../../../../Auth/SignupModal/SignupModal";

export default function PricingPlans() {
  const [showModal, setShowModal] = useState(false);
  const [subscribtionPlans, setSubscribtionPlans] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showSubscribeButton, setShowSubscribeButton] = useState(true);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  const handleLoginModalClose = () => setShowLoginModal(false);
  const handleLoginModalShow = () => setShowLoginModal(true);

  const handleSignUpModalClose = () => setShowSignUpModal(false);
  const handleSignUpModalShow = () => {
    setShowLoginModal(false);
    setShowSignUpModal(true);
  };

  let subScriptionData = sessionStorage.getItem("subScriptionData");
  // let subscriptionStatus;
  if (subScriptionData) {
    // subscriptionStatus = JSON.parse(subScriptionData)?.subscriptionStatusInfo;
    subScriptionData = JSON.parse(subScriptionData)?.subscribedPlan;
  }

  const getPricingPlans = async () => {
    const getDataResponse = await getData("get-pricing-plan");
    const plansWithCurrentData = getDataResponse?.data?.data.map((plan) => ({
      ...plan,
      current_data_gb: plan.data_min_gb,
    }));
    setSubscribtionPlans(plansWithCurrentData || []);
  };

  useEffect(() => {
    const userDetails = GetUserDetails();
    if (userDetails != null) {
      // if (userDetails.isAdmin) {
      //   setShowSubscribeButton(false);
      // }
      if (userDetails?.roleId != 3) {
        setShowSubscribeButton(false);
      }
    }
    setUserDetails(userDetails);
    getPricingPlans();
  }, []);

  const openModal = (plan) => {
    if (!userDetails) {
      handleLoginModalShow();
    } else {
      setShowModal(true);
      setSelectedPlan(plan);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const calculateFinalAmountPackage = (
    amount,
    increaseAmount,
    discountPercentage
  ) => {
    let discountAmount = (increaseAmount * discountPercentage) / 100;
    discountAmount = parseFloat(discountAmount.toFixed(2));
    let finalAmount = increaseAmount - discountAmount;
    return amount + finalAmount;
  };

  const calculateFinalAmountPackageDecrement = (
    amount,
    decreaseAmount,
    discountPercentage
  ) => {
    let discountAmount = (decreaseAmount * discountPercentage) / 100;
    discountAmount = parseFloat(discountAmount.toFixed(2));
    let finalAmount = decreaseAmount - discountAmount;
    return amount - finalAmount;
  };

  const incrementStorage = (plan) => {
    const price_per_data = plan.price_per_data;
    const price_percentage_off = plan.price_percentage_off;
    const data_max_gb = plan.data_max_gb;
    const data_step_gb = plan.data_step_gb;

    const newAmount = calculateFinalAmountPackage(
      plan.price_initial,
      price_per_data,
      price_percentage_off
    );

    if (
      data_max_gb === 0 ||
      plan.current_data_gb + data_step_gb <= data_max_gb
    ) {
      const updatedPlans = subscribtionPlans.map((p) => {
        if (p.id === plan.id) {
          return {
            ...p,
            current_data_gb: p.current_data_gb + data_step_gb,
            price_initial: newAmount,
          };
        }
        return p;
      });
      setSubscribtionPlans(updatedPlans);
    }
  };

  const decrementStorage = (plan) => {
    const data_step_gb = plan.data_step_gb;
    const price_per_data = plan.price_per_data;
    const price_percentage_off = plan.price_percentage_off;

    const newAmount = calculateFinalAmountPackageDecrement(
      plan.price_initial,
      price_per_data,
      price_percentage_off
    );

    if (plan.current_data_gb - data_step_gb >= plan.data_min_gb) {
      const updatedPlans = subscribtionPlans.map((p) => {
        if (p.id === plan.id) {
          return {
            ...p,
            current_data_gb: p.current_data_gb - data_step_gb,
            price_initial: newAmount,
          };
        }
        return p;
      });
      setSubscribtionPlans(updatedPlans);
    }
  };

  // Slick slider settings
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="PricingPlans" id="Pricing">
        <div className="container py-5">
          <div className="row">
            <div className="headerIneer">
              <div className="main">
                <p className="paragraph1 py-3 pb-0 fs-5 fw-bold text-center">
                  Pricing Plans
                </p>
                <h1 className="fw-bold pt-2 text-center py-4">
                  Plans that suit you best
                </h1>
              </div>
            </div>
            <Slider {...settings}>
              {subscribtionPlans.map((plan) => (
                <div className="col-lg-3" key={plan.id}>
                  <div
                    className={`cardPrice py-5 mx-3 my-4 ${
                      subScriptionData?.id === plan.id &&
                      "position-relative overflow-hidden"
                    }`}
                  >
                    {subScriptionData?.id === plan.id && (
                      <div className="purchase-ribbon">Current Plan</div>
                    )}
                    <h4 className="basicText">{plan.title}</h4>
                    <div className="headerPrice py-4">
                      <h5 className="text-center">{plan.name}</h5>
                    </div>
                    <div className="text-danger text-center fs-5">
                      {plan.sale_text === null ? "..." : plan.sale_text}
                    </div>
                    <span className="d-flex align-items-center justify-content-center">
                      <svg
                        className="tickColor w-3.5 h-3.5 mx-2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="#60ce71"
                          d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"
                        ></path>
                      </svg>
                      <h3 className="">{plan.current_data_gb} GB</h3>
                      <span className="ml-4 py-4">
                        <button
                          className="text-[30px] cursor-pointer custom-class my-2"
                          onClick={() => incrementStorage(plan)}
                          disabled = { plan.price_initial < 1 }
                        >
                          +
                        </button>
                        <div>&nbsp;</div>
                        <button
                          className="text-[30px] cursor-pointer custom-class my-2"
                          onClick={() => decrementStorage(plan)}
                          disabled = { plan.price_initial < 1 }
                        >
                          -
                        </button>
                      </span>
                    </span>
                    <p className="relative fw-bold flex text-[40px] font-semibold tracking-tight leading-none mb-2 mt-2 text-center text-cyan-500">
                      ${plan.price_initial.toFixed(2)}
                    </p>
                    {showSubscribeButton && (
                      <button
                        type="button"
                        className={`d-flex m-auto w-50 rounded-5 p-2 justify-content-center my-2 btn btn-outline-success`}
                        onClick={() =>
                          openModal({
                            name: plan?.name,
                            storage: plan.current_data_gb,
                            amount: plan.price_initial.toFixed(2),
                            id: plan?.id,
                          })
                        }
                        disabled = { plan.price_initial < 1 && subScriptionData?.id }
                      >
                        subscribe
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <SubscriptionModal
        showModal={showModal}
        closeModal={closeModal}
        userDetails={userDetails}
        planDetails={selectedPlan}
      />

      <LoginModal
        show={showLoginModal}
        handleClose={handleLoginModalClose}
        handleSignUp={handleSignUpModalShow}
        showLoginModal={() => {}}
      />
      <SignupModal
        show={showSignUpModal}
        handleClose={handleSignUpModalClose}
      />
    </>
  );
}
